var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "white",
    opacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8796 2.23593C16.6424 1.79467 17.2277 1.09498 17.5024 0.261489C16.7882 0.671086 15.9989 0.967304 15.1569 1.12767C14.4849 0.433091 13.5246 0 12.4617 0C10.4226 0 8.77021 1.59855 8.77021 3.56993C8.77021 3.84981 8.80085 4.12253 8.86424 4.383C5.79609 4.23387 3.07554 2.81407 1.25304 0.6527C0.935024 1.18181 0.753302 1.79467 0.753302 2.44839C0.753302 3.68638 1.40518 4.77932 2.3962 5.42078C1.79081 5.4024 1.22134 5.23999 0.722662 4.97441V5.01833C0.722662 6.74865 1.99472 8.19195 3.68621 8.51881C3.37559 8.60257 3.05018 8.64445 2.7121 8.64445C2.47438 8.64445 2.24194 8.623 2.01796 8.58112C2.48706 9.99888 3.85103 11.0326 5.46751 11.0602C4.20285 12.0183 2.61067 12.5882 0.881141 12.5882C0.583201 12.5882 0.288431 12.5729 0 12.5392C1.63444 13.5514 3.57528 14.1429 5.66086 14.1429C12.4543 14.1429 16.1669 8.70267 16.1669 3.98464C16.1669 3.82938 16.1648 3.67514 16.1574 3.52295C16.879 3.01938 17.5066 2.39017 18 1.67414C17.3376 1.9581 16.6255 2.15013 15.8796 2.23593Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c82a3c60.svg";
export { ForwardRef as ReactComponent };